import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const FontFamilyValue = z.string();
export const FontFamilyTokenData = tokenAliasOrValue(FontFamilyValue);

export type FontFamilyValue = z.infer<typeof FontFamilyValue>;
export type FontFamilyTokenData = z.infer<typeof FontFamilyTokenData>;
